<template>
	<div>
		<NavHeader />

		<div class="divider"></div>


		<div class="container">
			<div class="process">
				<h3>Sending money made easy with eRemit</h3>

				<div class="process-timeline">
					<div class="process-list">
						<img src="/static/commercial/img/icons/recipient.png" alt="">
						<p>Enter recipient details & amount</p>
					</div>

					<img src="/static/commercial/img/icons/line.png" alt="" class="line">

					<div class="process-list">
						<img src="/static/commercial/img/icons/payment.png" alt="">
						<p>Make Payment</p>
					</div>

					<img src="/static/commercial/img/icons/line.png" alt="" class="line">

					<div class="process-list">
						<img src="/static/commercial/img/icons/money.png" alt="">
						<p>Money transfered</p>
					</div>

				</div>
			</div>
			<!-- eo process -->
		</div>

		<div class="divider"></div>


		<div class="video-box video-box-blue">
			<div class="main-video mb-0">
				<a href="https://www.youtube.com/watch?v=pInvuLEzzpU">
					<img src="/static/commercial/img/pic-video-ekyc.jpg" alt="">
				</a>
				<!-- <video controls="controls" type="video/mp4">
		  	<source src="video/eremit.mp4" type="video/mp4">
		</video> -->
			</div>

			<div class="text-content">
				<h3>Sign up with "Just A Selfie"</h3>
				<p>Easy Registration & Online Document Submission (e-KYC)</p>
				<a href="https://eremit.com.my/account/registration/initial" class="theme-btn">Sign Up Now</a>
			</div>
		</div>

		<div class="mode mode-personal">
			<div class="container">
				<div class="second-header">
					<h3>Modes of Payment</h3>
					<div class="row">
						<div class="col-lg-3 text-center">
							<div class="modes">
								<div class="mode-list">
									<img src="/static/commercial/img/icons/accountcredit.png" alt="">
									<p>Account Credit / Bank Transfer</p>
								</div>

								<!-- <div class="mode-list">
									<img src="/static/commercial/img/icons/cashpickup.png" alt="">
									<p>Cash Pickup</p>
								</div> -->
							</div>
						</div>
						<div class="col-lg-9">
							<p class="normal">Payments can be deposited directly into the Receipient's bank account. The
								Recipient may withdraw money deposited through Auto-Teller-Machines (ATM). The following
								are the countries that allows monies to be transferred to an "Individual Account" or a
								"Business/Company Account"</p>
							<div class="divider"></div>
							<div>
								<div class="main-table">
									<div class="table-responsive-md c-table-border">
										<table class="table table-striped table-bordered table-radius">
											<thead>
												<tr>
													<th scope="col">Country</th>
													<th scope="col">Individual Account</th>
													<th scope="col">Business/Company Account</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="item in vModel.bankTransferList" :key="item.FlagCode">
													<td class="text-left" style="width: 40%;">
														<img :src="'/static/flags/'+item.FlagCode+'.png'"
															class="f-small">
														{{item.Country}}
													</td>
													<td style="width:30%">
														<span class="btn-circle" v-if="item.IA">
															<i class="material-icons">check</i>
														</span>
													</td>
													<td style="width:30%">
														<span class="btn-circle" v-if="item.BA">
															<i class="material-icons">check</i>
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<!-- <div class="col-lg-6">
						<h4>Send money the way suits you</h4>
					</div>

					<div class="col-lg-6">
						<div class="modes">
							<div class="mode-list">
								<img src="/static/commercial/img/icons/accountcredit.png" alt="">
								<p>Account Credit</p>
							</div>

							<div class="mode-list">
								<img src="/static/commercial/img/icons/cashpickup.png" alt="">
								<p>Cash Pickup</p>
							</div>
						</div>
					</div> -->
					</div>
					<div class="divider"></div>
					<div class="row">
						<div class="col-lg-3 text-center">
							<div class="modes">
								<div class="mode-list">
									<img src="/static/commercial/img/icons/cashpickup.png" alt="">
									<p>Cash Pickup</p>
								</div>
							</div>
						</div>
						<div class="col-lg-9">
							<p class="normal">For Recipients who do not have bank account, they can collect the cash
								from the bank branches or designated cash-pick up centers. Available Countries:
								Philippines, Indonesia, Sri Lanka, Bangladesh, Nepal, Myanmar and Vietnam.</p>
						</div>
					</div>
					<div class="divider"></div>
					<h3>FPX Banks <br /> (Individual / Retail Internet Banking)</h3>
					<div class="row">
						<div class="col-lg-12">
							<div class="main-table wb-main-table">
								<div class="table-responsive-md c-table-border">
									<table border="1" class="table table-striped table-bordered">
										<tbody>
											<tr v-for="(item,index) in vModel.fpxBanks" :key="{index}">
												<td style="width:33%;" v-for="subItem in item" :key="subItem.Id">
													{{subItem.BankDesc}}</td>
												<td v-if="item.length<3" :colspan="3-item.length"></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- eo row -->
			</div>
		</div>
		<!-- eo mode -->


		<div class="divider"></div>


		<div class="container mgb30">

			<div class="second-header works-lists">
				<h3>Delivery Time</h3>

				<!-- <ul class="works-list-here">
					<li class="text-left">• Service charges shown below are based on per transaction basis</li>
				</ul> -->

				<div class="row">
					<!-- <div class="form"> -->
					<div class="col-md-6">
						<div class="form-group">
							<label>Country</label>
							<div class="main-form">
								<div class="currency-dropdown currency-dropdown-round">
									<kendo-dropdownlist ref="kendoCountryList" v-if="vModel.Countries"
										:data-value-field="'CountryId'" :data-value-text="'CountryName'"
										:option-label="'Select Country'" :valueTemplate="countryItemTemplate"
										:template="countryItemTemplate" :data-source="vModel.Countries"
										:data-value-primitive="true" @change="changePaymentMode">
									</kendo-dropdownlist>
								</div>
							</div>

						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Payment Mode</label>
							<div class="main-form">
								<div class="currency-dropdown currency-dropdown-round">
									<kendo-dropdownlist ref="kendoPayoutList" :data-value-field="'Id'"
										:data-value-text="'Text'" :option-label="'Select Payment Mode'"
										:valueTemplate="payoutItemTemplate" :template="payoutItemTemplate"
										:data-source="vModel.PayoutModes" :data-value-primitive="true"
										@change="showLimit">
									</kendo-dropdownlist>
								</div>
							</div>

						</div>
					</div>
					<!-- </div> -->
				</div>
			</div>

			<div class="main-table" v-if="SlaText">
				<div class="table-responsive-md">
					<table class="table table-striped table-bordered">
						<thead>
							<tr>
								<!-- <th scope="col">Payable Amount</th> -->
								<th scope="col" colspan="2">Delivery Time</th>
								<!-- <th scope="col" colspan="2">Service Charge</th> -->
							</tr>
						</thead>
						<tbody>
							<tr>
								<td v-html="SlaText"></td>
							</tr>
							<!-- <tr :key="item.Details" v-for="item in vModel.selectedPaymentMode.SlaNotifications">
								<td>{{item.LowerLimit}}</td>
								<td>{{item.CutOfTime}}</td>
								<td> {{item.DeliverySchedule}}</td>
								<td>{{item.ServiceCharge}}</td>
							</tr> -->
						</tbody>
					</table>
				</div>
			</div>
			<!-- eo main table -->
		</div>


		<div class="divider"></div>
		<DownloadApp />
		<SignUpFooter />
	</div>
</template>
<script>
	import DownloadApp from "../../shared/commercial//DownloadApp.vue";
	import NavHeader from "../../shared/commercial/NavHeader.vue";
	import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";
	import ListService from "../../services/list";
	export default {
		name: "Dashboard",

		components: { DownloadApp, NavHeader, SignUpFooter },
		beforeRouteEnter(to, from, next) {
			Promise.all([
				//ListService.get('/static/data/service.json'),
				ListService.get('list/slaweblist'),
				ListService.get("payment/providers"),
				ListService.get('list/countrywisemode'),
				//ListService.get('/static/data/banktranferpersonal.json'),

			]).then(responses => {
				next(vm => {
					var rates = [];
					var countries = [];

					responses[0].body.forEach(p => {
						countries.push({
							CountryId: p.CountryId,
							CountryName: p.CountryName,
							FlagCode: p.FlagCode,
							PayoutModes: p.PaymentModes.map(a =>
								Object.assign({
									Id: a.Id,
									Text: a.Text,
									Logo: (a.Text === "Bank Account"||a.Text=="Union Pay Card") ? "bank" : "swift",
									//SlaNotifications: a.Details,
									SlaText: a.SlaText
								})
							)
						});

						rates.push({
							ExchangeRateId: p.Id, //p.ExchangeRateId,
							FlagCode: p.FlagCode,
							CurrencyCode: p.CurrencyCode,
							CountryName: p.Text, //p.CountryName,
							ExchangeRate: p.ExchangeRate
						});
					});
					vm.vModel.Countries = countries;
					vm.vModel.Rates = rates;
					var activeBanks = responses[1].body.Individual;
					vm.vModel.fpxBanks = activeBanks.map((e, i) => {
						return i % 3 === 0 ? activeBanks.slice(i, i + 3) : null;
					}).filter(i => {
						return i;
					});
					vm.vModel.bankTransferList = responses[2].body
				});
			});
		},
		mounted: function () {
			//  this.$nextTick(function() {
			// 	this.$refs.kendoCountryList
			//     .kendoWidget()
			//     .setDataSource(this.vModel.Countries);
			// 	this.$refs.kendoCountryList.kendoWidget().select(0);
			// 	this.$refs.kendoPayoutList
			//     .kendoWidget()
			//     .setDataSource(this.$refs.kendoCountryList.kendoWidget().dataItem(0).toJSON().PayoutModes);
			//   this.$refs.kendoPayoutList.kendoWidget().select(0);
			// });
		},
		data() {
			return {
				itemTemplate:
					'<div class="m-b-sm m-t-sm"><img style="width:48px;margin-right:10px;" src="/static/flags/#:data.FlagCode#.png" />#:data.CountryName#</div>',
				countryItemTemplate:
					'<div class="m-b-sm m-t-sm"><img style="width:48px;margin-right:10px;" src="/static/flags/#:data.FlagCode#.png" />#:data.CountryName#</div>',
				payoutItemTemplate:
					'<div class="m-b-sm m-t-sm"><img style="width:48px;margin-right:10px;" src="/static/commercial/img/icons/#:data.Logo#.png" />#:data.Text#</div>',
				vModel: {
					Rates: null,
					Countries: null,
					PayoutModes: null,
					selectedPaymentMode: null,
					bankTransferList: [],
					fpxBanks: []
				},
				SelectedCountryId: null,
				SelectedPayoutmodeId: null,
				SlaText: "",
			};
		},
		methods: {
			changePaymentMode(e) {
				let self = this;
				this.SelectedCountryId = null;
				this.SelectedPayoutmodeId = null;
				this.SlaText = "";
				this.vModel.selectedPaymentMode = null;
				this.$refs.kendoPayoutList
					.kendoWidget()
					.setDataSource([]);
				var selectedIndex = e.sender.select();
				if(selectedIndex==0||selectedIndex=='0'||!selectedIndex)
					return false;
				var selectedItem = e.sender.dataItem(selectedIndex).toJSON();

				this.SelectedCountryId = e.sender.value();
				this.$refs.kendoPayoutList
					.kendoWidget()
					.setDataSource(selectedItem.PayoutModes);
				this.$refs.kendoPayoutList.kendoWidget().select(0);
				
			},
			showLimit(e) {
				let self = this;
				this.SlaText = "";
				this.SelectedPayoutmodeId = null;
				this.SelectedPayoutmodeId = e.sender.value();
				var selectedIndex = e.sender.select();
				if(selectedIndex==0||selectedIndex=='0'||!selectedIndex)
					return false;
				this.vModel.selectedPaymentMode = e.sender
					.dataItem(selectedIndex)
					.toJSON();
					if(!this.SelectedPayoutmodeId||!this.SelectedCountryId)
					return false;
				  ListService.get(`list/getslatext/${this.SelectedCountryId}/${this.SelectedPayoutmodeId}`).then(x=>{
					self.SlaText=x.body;
				 })
			}

		}
	};
</script>